// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2674e912","455":"05b59f59","977":"ff49e75a"}[chunkId] + ".chunk.js";
};